import { createFileRoute } from "@tanstack/react-router";

import AccountVerificationPage from "./-components/AccountVerificationPage";

export const Route = createFileRoute("/_app/_dashboard/accountverification/")({
  component: AccountVerificationPage,
});
